var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MinigamesContainer',[_c('TournamentContact',{attrs:{"icon":"globe","text":"https://support.vkplay.ru/pvp","link":"https://support.vkplay.ru/pvp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }